import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage';

import { PageMode } from './enums';

export const useGetPageMode = () => {
	const isLivePage = useIsCurrentPageLive();
	const isEditorPage = useIsEditorPage();

	let pageMode = PageMode.VIEW;
	if (isLivePage) {
		pageMode = PageMode.LIVE;
	} else if (isEditorPage) {
		pageMode = PageMode.EDIT;
	}
	return pageMode;
};
